import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2603511e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
import { ref, watch, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { getAllPermissionList } from '@/api/permission';
import { useVModel, useDebounceFn } from '@vueuse/core';
export default {
  __name: 'Permission',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'distributePermissionToMenu'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const isVisible = useVModel(props);
    const multipleTableRef = ref(null);
    const multipleSelection = ref([]);

    /**
      确定按钮点击事件
     */
    const onConfirm = async () => {
      const data = multipleTableRef.value.getSelectionRows().map(item => ({
        permissionId: item.id
      }));
      try {
        ElMessage({
          message: '分配成功',
          type: 'success'
        });
        closed();
        emits('distributePermissionToMenu', data);
      } catch (error) {
        console.log(error);
        ElMessage({
          message: '分配失败',
          type: 'warning'
        });
        closed(); // 角色更新成功
      }
    };

    /**
     * 关闭
     */
    const closed = () => {
      isVisible.value = false;
    };

    // 所有权限
    const allPermission = ref([]);
    const search = ref('');
    const permission = ref([]);
    const getPermissionList = async () => {
      const res = await getAllPermissionList();
      allPermission.value = res;
      permission.value = allPermission.value;
    };
    getPermissionList();

    // 属性结构配置
    // const defaultProps = {
    //   children: 'childPermissions',
    //   label: 'name'
    // }

    // tree 节点

    const loading = ref(false);
    // 获取当前用户角色的权限
    const selection = ref([]);
    const getRolePermission = async () => {
      var _props$model$permissi, _multipleTableRef$val;
      loading.value = true;
      const res = (_props$model$permissi = props.model.permissionId) === null || _props$model$permissi === void 0 ? void 0 : _props$model$permissi.split(',');
      if (!(res !== null && res !== void 0 && res.length)) return loading.value = false;
      multipleSelection.value = allPermission.value.filter(item => {
        return res.find(val => val === item.id);
      });
      multipleSelection.value.forEach(item => {
        multipleTableRef.value.toggleRowSelection(item, true);
      });
      selection.value = (_multipleTableRef$val = multipleTableRef.value) === null || _multipleTableRef$val === void 0 ? void 0 : _multipleTableRef$val.getSelectionRows();
      loading.value = false;
    };
    const handSelect = e => {
      selection.value = e;
    };
    const handleSearch = useDebounceFn(async e => {
      var _multipleTableRef$val2;
      loading.value = true;
      search.value = e;
      (_multipleTableRef$val2 = multipleTableRef.value) === null || _multipleTableRef$val2 === void 0 || _multipleTableRef$val2.clearSelection();
      const res = await getAllPermissionList({
        keyword: search.value
      });
      permission.value = allPermission.value.filter(item => {
        return res.find(val => val.id === item.id);
      });
      setTimeout(() => {
        selection.value.forEach(item => {
          multipleTableRef.value.toggleRowSelection(item, true);
        });
      }, 200);
      loading.value = false;
    }, 300);
    watch(() => props.modelValue, async val => {
      if (val) {
        var _multipleTableRef$val3;
        await nextTick();
        (_multipleTableRef$val3 = multipleTableRef.value) === null || _multipleTableRef$val3 === void 0 || _multipleTableRef$val3.clearSelection();
        getRolePermission();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "分配权限",
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        onClose: closed,
        width: "60%",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        class: "dialog-class"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: closed
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          class: "dialog-content"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
            ref_key: "multipleTableRef",
            ref: multipleTableRef,
            data: permission.value,
            "row-key": "id",
            onSelect: handSelect
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }), _createVNode(_component_el_table_column, {
              label: "权限名",
              prop: "name"
            }), _createVNode(_component_el_table_column, {
              label: "路径",
              prop: "url"
            }), _createVNode(_component_el_table_column, {
              prop: "tag",
              "show-overflow-tooltip": ""
            }, {
              header: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
                onInput: _unref(handleSearch),
                size: "small",
                placeholder: "请输入关键字"
              }, null, 8, ["modelValue", "onInput"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};